import { createStateHook } from 'react-sweet-state';
import { store } from '../../main';
export var useNotification = createStateHook(store, {
  selector: function selector(state) {
    return state.notification;
  }
});